export default function lockedName({ isLevelBased, isReferralBased }) {
    let msg = "";
    if(isLevelBased !== null) msg += `${isLevelBased?.title} Lvl ${isLevelBased?.levelUp}`
    if(isReferralBased !== null) msg += `Refer ${isReferralBased?.referralCount} friend${(isReferralBased?.referralCount) > 1 ? "s" : ""}`
    return msg
}